import { createUUID as e } from "@magnopus-opensource/magnopus-web-common";
//#region src/lib/utils/chat.ts
var t = 1024, n = ({ message: n, userDisplayName: r, userId: i, avatarId: a }) => {
	let o = e(), s = Date.now();
	return {
		id: o,
		message: n.substring(0, t),
		timestamp: s,
		userId: i,
		userDisplayName: r,
		avatarId: a
	};
}, r = (e) => ({
	...e,
	dateTime: i(e.timestamp)
}), i = (e) => {
	let t = new Date(e);
	return t.setSeconds(0), t.setMilliseconds(0), t;
}, a = (e) => {
	let t = new Date(e);
	return t.setSeconds(0), t.setMilliseconds(0), t;
}, o = (e) => {
	let [t] = e;
	return {
		groupId: s({
			userId: t.userId,
			timestamp: t.timestamp,
			firstMessageId: t.id
		}),
		userDisplayName: t.userDisplayName,
		userId: t.userId,
		avatarId: t.avatarId,
		texts: e.map(({ dateTime: e, timestamp: t, message: n, id: r, isSending: i }) => ({
			dateTime: e,
			timestamp: t,
			message: n,
			id: r,
			isSending: i
		}))
	};
}, s = ({ userId: e, timestamp: t, firstMessageId: n }) => `userId:${e}_timestamp:${t}_firstMessageId:${n}`;
//#endregion
export { t as MAX_CHAT_MESSAGE_LENGTH, i as convertDate, a as convertMessageDate, r as convertNewMessage, o as createMessageGroup, n as createNewChatMessage, s as generateGroupId };
